import { render } from "./ShareDocument.vue?vue&type=template&id=a3fcee40&scoped=true&ts=true"
import script from "./ShareDocument.vue?vue&type=script&lang=ts"
export * from "./ShareDocument.vue?vue&type=script&lang=ts"

import "./ShareDocument.vue?vue&type=style&index=0&id=a3fcee40&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3fcee40"]])

export default __exports__